import { Suspense } from 'react';

import { AppLoader } from '@/shared/components/feedback/AppLoader';
import { Outlet } from 'react-router-dom';

/**
 * The frame around sign-in, sign-up and activation.
 *
 * <p>Separate from the application shell because these pages have no navigation,
 * no user and nothing to sign out of. Sharing one layout would mean every item in
 * it asking whether anybody is signed in.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Suspense fallback={<AppLoader />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
}
